import React, { Fragment, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../Button';
import PinchZoomPan from '../../../PinchZoomPan';
import { IMAGE_SIZE_CODE } from '../../../../../constants/image-size-codes';
import { getThumbBySize } from '../../../../../util/photo';
import useComponentSize from '../../../../../hooks/useComponentSize';
import PhotosIcon from '../../../../icons/PhotosIcon';

const propTypes = {
  position: PropTypes.number.isRequired,
  photo: PropTypes.shape({
    id: PropTypes.string,
    thumbnail_urls: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)),
      }),
    ),
  }),
  onEdit: PropTypes.func.isRequired,
  onPhotoCropboxSet: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
};

const CustomPrintPanZoomPhoto = ({
  position,
  photo,
  onEdit,
  onPhotoCropboxSet,
  className,
  label = 'Press to select a photo',
}) => {
  const photoWrapRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const containerSize = useComponentSize(photoWrapRef);

  return (
    <div
      ref={photoWrapRef}
      className={classNames({
        'custom-print-photo-placeholder': true,
        'has-photo': !!photo,
        loading: photo && !imageLoaded,
        [className]: !!className,
      })}
    >
      <span className="custom-print-photo-placeholder-number">
        {position + 1}
      </span>

      {photo ? (
        <Fragment>
          <PinchZoomPan
            key={photo.id}
            maxScale={10}
            initialRotation={0}
            initialLeft={0}
            initialTop={0}
            initialScale={1}
            onChange={({ x, y, scale, rotation }) => {
              const cropbox = {
                x: x / containerSize.width,
                y: y / containerSize.height,
                scale,
                rotation,
              };
              onPhotoCropboxSet(position, cropbox);
            }}
          >
            <img
              src={
                getThumbBySize(photo.thumbnail_urls, IMAGE_SIZE_CODE.LARGE).url
              }
              alt=""
              className="custom-print-photo-placeholder-img"
              onLoad={() => setImageLoaded(true)}
            />
          </PinchZoomPan>

          <span className="waldogram-edit-buttons-centered">
            <Button
              className="btn-edit-photo-selection btn-sm"
              onClick={() => onEdit(position)}
            >
              Change photo
            </Button>
          </span>
        </Fragment>
      ) : (
        <button
          className="custom-print-photo-placeholder-button"
          onClick={() => onEdit(position)}
        >
          <PhotosIcon color="#8CA4C9" size={48} className="mb-2" />
          <span className="custom-print-photo-placeholder-label">{label}</span>
        </button>
      )}
    </div>
  );
};

CustomPrintPanZoomPhoto.propTypes = propTypes;

export default CustomPrintPanZoomPhoto;
